import consumerApi from "@/api/services/consumer-api";
import publicConfig from "@/config/public";
import logError from "@/utils/logError";

import { MenuItemCard } from "../../../custom-types/MenuItemCard";

export enum FILTER_CONFIG_OPTIONS {
  SHOP_MENU = "shop_menu",
  BRAND_MENU = "brand_menu",
  SUBCATEGORY_MENU = "subcategory_menu",
}
type SortDirection = "asc" | "desc";

export type Filter = { [key: string]: string | boolean | string[] };

export type GetMenuItemsV3Params = {
  boost?: string;
  boost_options?: { [key: string]: string };
  decorate_with_user_fulfillment?: boolean;
  filter_config?: FILTER_CONFIG_OPTIONS;
  filters?: Filter;
  q?: string;
  skip?: number;
  sort?: string;
  sortDirection?: SortDirection;
  take?: number;
};

// * Custom types for this response
type AvailableFilter = {
  label: string;
  name: string;
  values: { value: string; count: number }[];
};

type Metadata = {
  availableFilters: AvailableFilter[];
  availableSorts: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  relevanceOrder?: any;
  supportedFilters?: string[];
  totalCount: number;
};

interface GetMenuItemsV3ApiResponse {
  data: MenuItemCard[];
  metadata: Metadata;
}

interface GetMenuItemsV3Response {
  data: GetMenuItemsV3ApiResponse;
}

const { timeout } = publicConfig;

const getMenuItemsV3 = async (
  lat: number,
  lon: number,
  {
    boost,
    boost_options,
    decorate_with_user_fulfillment,
    filter_config,
    q,
    skip,
    sort,
    take,
    sortDirection = "asc",
    filters = {},
  }: GetMenuItemsV3Params,
): Promise<GetMenuItemsV3Response> => {
  const searchParams = {
    boost,
    ...(boost_options?.strain_name && {
      "boost_options[strain_name]": boost_options.strain_name,
    }),
    ...(boost_options?.brand_name && {
      "boost_options[brand_name]": boost_options.brand_name,
    }),
    decorate_with_user_fulfillment,
    filter_config,
    lat,
    lon,
    q,
    skip,
    ...(sort && sort.length > 0 ? { [`sort[0][${sort}]`]: sortDirection } : {}),
    take,
    ...filters,
  };

  try {
    return (await consumerApi.get(`/api/menu_items/v3`, {
      params: searchParams,
      timeout: timeout.deliverySearch,
    })) as GetMenuItemsV3Response;
  } catch (e) {
    logError(e.message, {
      functionName: "getMenuItemsV2",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      data: {
        data: [],
        metadata: {
          availableFilters: [],
          availableSorts: [],
          supportedFilters: [],
          totalCount: 0,
        },
      },
    };
  }
};

export default getMenuItemsV3;
